<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Chapter-Title-Page-Break--Body-" id="a__The_Great_White">The Great White Way</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0008title.vue?39e7e762